import config from "./../config";
const ENV = process.env.REACT_APP_ENVIRONMENT;
export const URL = config?.config?.api?.COURSE_API;
export const URL_COHORT = config?.config?.api?.COHORT_API;
export const IS_UNDER_MAINTENANCE = false;